<template>
  <div class="scroll-top-to" @click="targetToTop">
    <i class="ti-angle-up"></i>
  </div> 
</template>

<script>
  export default {
    methods: {
      targetToTop: function(){
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
    }}
</script>

<style scoped>
</style>